import { createAction } from '@reduxjs/toolkit'

 const setRefreshlist = createAction<{refreshLiquidityState:boolean}>('liquidityList/setRefresh')
 export default setRefreshlist;